import { chatbotActionButton } from '../../components/action-buttons/action-buttons.consts';
import { ButtonColor } from '../../components/action-buttons/action-buttons.types';
import {
  ActionTooltip,
  VendorsActionButton,
  VendorsActionName,
  VisibilityRule,
} from './vendors-list.types';

/** User-settings key the column configuration is saved under. */
export const VENDORS_COLUMN_LIST = 'column_list-vendors';

/** Form key the plant's allowed fields are read under. */
export const VENDORS_FIELDS_KEY = 'VENDORS_MODULE_FORMKEY';

/** Namespace the column captions are translated from, by field name. */
export const VENDORS_COLUMN_LABEL_PREFIX = 'defaultFields.vendors-module.';

/** Kept so a second click reuses the dialog rather than opening another. */
export const VENDORS_COLUMNS_DIALOG_ID = 'vendors-select-columns-dialog';

export const VENDORS_TEST_IDS = {
  columnSelect: 'vendors-column-select',
} as const;

export const vendorsActionButtons: VendorsActionButton[] = [
  {
    color: ButtonColor.Red,
    icon: 'add',
    name: VendorsActionName.ADD,
    tooltipKey: ActionTooltip.ADD,
    visibilityRule: VisibilityRule.ADD,
  },
  chatbotActionButton(VendorsActionName.CHATBOT),
];
